import React from "react";

import { CustomMenuItemProps } from "ag-grid-react";
import { useGridMenuItem } from "ag-grid-react";
import ProcessusLink from "composants/processus/ProcessusLink";
import { ProcessusDefinition } from "types/Processus";
import { ProcessusProvider } from "composants/processus/ProcessusProvider";
import { Pojo } from "types/Galaxy";

export interface ButtonCustomMenuItemProps extends CustomMenuItemProps {
  buttonValue: string;
  definition: ProcessusDefinition;
  selected: Pojo;
  sjmoCode: string;
  tableName: string;
}

export default function MenuItem({
  name,
  subMenu,
  definition,
  selected,
  sjmoCode,
  tableName
}: ButtonCustomMenuItemProps) {
  useGridMenuItem({
    configureDefaults: () => true
  });

  return (
    <div>
      <span className="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
      <span className="ag-menu-option-part ag-menu-option-shortcut">
        <ProcessusProvider sjmoCode={sjmoCode} tableName={tableName} selected={selected}>
          <ProcessusLink key={definition.id} definition={definition} canDelayProcess />
        </ProcessusProvider>
      </span>
      <span className="ag-menu-option-part ag-menu-option-popup-pointer">
        {subMenu && (
          <span
            className="ag-icon ag-icon-small-right"
            unselectable="on"
            role="presentation"
          ></span>
        )}
      </span>
    </div>
  );
}
